import type { Factory } from 'walden-fast/types/mocks';
import type {
  TraceOrder,
  TraceOrderState,
} from 'walden-fast/types/trace-order';
import { selectRandom } from './lists';

const MOCK_ORDER: TraceOrder = {
  id: '1',
  description: 'Order 1',
  sentDate: new Date(1732721945000),
  state: 'received',
};

export const traceOrderFactory: Factory<TraceOrder> = (overrides) => ({
  ...MOCK_ORDER,
  id: `${Math.floor(Math.random() * 1000000000)}`,
  description: `Order ${Math.floor(Math.random() * 1000000000)}`,
  sentDate: new Date(1733750902000 + Math.random() * 10000000),
  state: selectRandom<TraceOrderState>([
    'received',
    'planned',
    'out-for-delivery',
    'delivered',
  ]),
  ...overrides,
});
